<template>
  <span
      class="badge-btn"
      :class="{ check }"
  >{{ text }}</span>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            default: '',
        },
        check: {
            type: Boolean,
            default: false,
        },
    }
}
</script>
<style lang="scss" scoped>
.badge-btn {
    font-size: 15px;
    min-height: 40px;
    border-radius: 1.8rem;
    padding-inline: 1rem;
    display: inline-flex;
    align-items: center;
    gap: .4rem;
    background-color: $blue;
    color: $white;
    box-sizing: border-box;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-user-select: none;
    touch-action: none;
    user-select: none;
    cursor: pointer;
    border: 1px solid transparent;

    &:before {
        font-size: 1.7rem;
        width: 1.8rem;
        min-width: 1.8rem;
        height: 1.8rem;
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }

    &:not(.check) {
        background: $black;
        border-color: $dark-2;
    }
}</style>
